import React from 'react'

import useSwr from 'swr'

import { Form } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablasPersonalizadasService from 'services/tablasPersonalizadas.service'

const fetcher = () =>
  TablasPersonalizadasService.getAsSelect(TiposTablaPersonalizadaConstant.LISTAPRECIO).then(({ data }) => data)

const ListaPrecioSelect = ({ oneRowTrigger, ...props }) => {
  const { data: listaPrecios } = useSwr('select_listaPrecios', fetcher, {
    initialData: [],
    revalidateOnMount: true,
    revalidateOnFocus: false,
    dedupingInterval: 1000 * 60 * 15
  })

  React.useEffect(() => {
    if (listaPrecios.length > 0 && oneRowTrigger) {
      oneRowTrigger(listaPrecios[0])
    }
  }, [listaPrecios, oneRowTrigger])

  return (
    <Form.Select {...props}>
      <option value=''>Seleccionar</option>
      {listaPrecios.map((val, key) => (
        <option key={key} value={val._id}>
          {val.nombre}
        </option>
      ))}
    </Form.Select>
  )
}

export default React.memo(ListaPrecioSelect)
